'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const CmsCarousel = dynamic(() => import('@/components/ui/cms-carousel'));

export type TestimonialSlide = {
  testimonial: string;
  title: string;
};

type TestimonialsRendererProps = {
  slides: TestimonialSlide[];
};

export const TestimonialsRenderer: React.FC<TestimonialsRendererProps> = ({
  slides,
}) => {
  const carouselSlides = slides.map((slide, index) => ({
    id: index,
    content: (
      <div className="flex flex-col items-center p-5">
        <blockquote className="mb-4 self-center text-sm max-sm:max-h-[120px] max-sm:overflow-hidden max-sm:text-ellipsis sm:text-base md:text-lg">
          <span className="relative top-1 mr-1 font-montserrat text-3xl text-gray-9">
            &ldquo;
          </span>
          {slide.testimonial}
          <span className="relative top-1.5 ml-1 font-montserrat text-3xl leading-[0] text-gray-9">
            &rdquo;
          </span>
        </blockquote>
        <cite className="caps-md">&ndash; {slide.title}</cite>
      </div>
    ),
  }));

  return (
    <CmsCarousel
      slides={carouselSlides}
      options={{ align: 'start', loop: true }}
      slideContainerClassName="grid grid-flow-col auto-cols-[100%] gap-4 items-center"
      slideWrapperClassName="w-full"
      slideClassName="w-full px-4"
      enableDots={true}
      autoplayOptions={{
        delay: 6000,
        stopOnInteraction: true,
        stopOnMouseEnter: true,
      }}
    />
  );
};
